import { ActionReducer, Action, RootStoreConfig } from "@ngrx/store";
import { IStore } from "./store";

import { RouterReducer } from "./router/router.reducers";

import { SearchReducer as ContactSearchReducer } from "./contact-search/search.reducers";
import { ApplicationReducer } from "./application/application.reducer";
import { ContactReducer } from "./contact/contact.reducers";
import { CompanyReducer } from "./company/company.reducers";
import {UserProfileReducer} from "./user-profile/user-profile.reducers";
import { techStackReducer } from "./tect-stack/tech-stack.reducer";
import {techStackInsightReducer} from "./insight/insight.reducer"

export const ReducerMap: { [key in keyof IStore]: (state: any, action: any) => any } = {
  router: RouterReducer,
  application: ApplicationReducer,
  contactSearch: ContactSearchReducer,
  contact: ContactReducer,
  company: CompanyReducer,
  userProfile: UserProfileReducer,
  techStack: techStackReducer,
  techStackInsight:techStackInsightReducer,
};

export const ReducerConfiguration: RootStoreConfig<IStore> = {
    metaReducers: [ClearState],
    runtimeChecks: {
        strictStateImmutability: true,
        strictActionImmutability: true,
        strictActionSerializability: false,
        strictStateSerializability: false,
    }
};

export function ClearState(reducer: ActionReducer<IStore>) {

    return (state: IStore, action: Action): IStore => {
        return reducer(state, action);
    };
}
